<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Change Transport Route</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>

        <v-row justify="center" dense>
           <v-col cols="12" sm="1"></v-col>
          <v-col cols="12" sm="2">
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay_change"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
              @change="getInstallmentData()"
            />
          </v-col>
          <v-col cols="12" sm="4" md="4" v-if="all_learner_list!=''">
               <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="learner"
              :items="all_learner_list"
              item-text="learner"
              item-value="id"
              label="Student"
              outlined
              persistent-hint
              hint="Please Select Student"
            />
                <!-- <v-autocomplete color="#0F2027" dense rounded required v-model="learner" :items="learner_list" item-text="learner" item-value="id" label="Student" outlined persistent-hint hint="Please Select Child" @change="getTransportDetails()"/> -->
          </v-col>
           <v-col col="12" sm="2" md="2" v-if="ay_change && learner">
            <v-btn color="warning" @click="fetchTransportApplications()">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>
      

    <v-card class="box" v-if="learner_transport_fees_installment_details!=''">
    <v-toolbar flat dense class="toolbar">
    <v-toolbar-title>Learner Transport Details</v-toolbar-title>
    <v-divider class="mx-4" inset vertical></v-divider>
    <v-spacer></v-spacer>
      </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="12">
            <v-simple-table  class="elevation-1">
              <template>
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Installment</th>
                    <th>Route</th>
                    <th>Stop Name</th>
                    <th>Distance Slab In KM</th>
                    <th>Fees In Rs.</th>
                    <th>Paid Till now</th>
                    <th>Change Bus Route</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, i) in learner_transport_fees_installment_details" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.transport_installment_name }}</td>
                    <td>{{ item.route }}</td>
                    <td>{{ item.route_stop }}</td>
                    <td>{{ item.distanceslab }}</td>
                    <td>{{ item.sync_amount }}</td>
                    <td>{{ item.paid_till_now }}</td>
                    <td>
                      <span v-if="item.raise_cancel_request && item.iscancelled==false">
                        <v-btn color="warning" @click="applyTransport(item.feesinstallmant_id)">Change</v-btn>
                      </span>
                      <span v-else-if="item.iscancelled">
                        Cannot Change..Request Cancelled
                      </span>
                      <span v-else> Cannot Change..Fees Paid</span>
                      </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card>

       <v-card class="box" v-if="show_apply_transport_card == true" >
        <v-card>
          <v-toolbar class="toolbar no-display" flat dense>
            <v-btn icon dark @click="show_apply_transport_card = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              <strong> Change Transport Route </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="4" md="4">
                <p><v-icon color="error">*</v-icon><b>Route Stop</b></p>
                <v-autocomplete color="#0F2027" dense rounded required v-model="route_stop" @change="getRoutes()" :items="route_stops" item-text="name" item-value="id" label="Route Stop" outlined persistent-hint hint="Please Select Route Stop"/>
              </v-col>
            </v-row>

            <v-row justify="center" dense v-if="route_details_list!=''">
              <v-col cols="12" sm="12" md="12">
                <v-simple-table dense class="elevation-1">
                  <template>
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>Route</th>
                        <th>Distance Slab In KM</th>
                        <th>Fees In Rs.</th>
                        <th>Select Route</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(item, i) in route_details_list" :key="i">
                        <td>{{ i + 1 }}</td>
                        <td>{{ item.route }}</td>
                        <td>{{ item.distance }}</td>
                        <td>{{ item.fees }}</td>
                        <td>
                          <input type="radio" name="selected_route" class="radiospace" v-model="selected_route" v-bind:value="item.id"/>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-row justify="center" class="pt-5" dense v-if="selected_route">
                  <v-btn small color="warning" @click="SaveUpdateTransport()"
                    >Save</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
      </v-card>

        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      tranport_fee_sync: false,
      learner_list:[],learner:"",
      ay_change:"",
      ay_list: [],
      learner_transport_fees_list:[],route_stops:[],all_transport_installments:[],
      selected_route:"",route_stop:"",route_details_list:[],learner_transport_fees_amount_id:"",apply_payment_card:false, show_fees:false,transport_installment:"",
      transport_installment_list:[],all_learner_list:[],learner_transport_fees_installment_details:[],
      show_apply_transport_card:false,selected_route:"",learnertransportfeesinstallment_id:""
  }),
   methods: {
     SaveUpdateTransport() {
      if (!confirm("Are You Sure You Want To Update...?")) return;
      const data = {
        academicYear: this.ay_change,
        selected_route: this.selected_route,
        learner: this.learner,
        route_stop:this.route_stop,
        learnertransportfeesinstallment:this.learnertransportfeesinstallment_id

      };
      this.overlay = true;
      axios
        .post("/ParentTransport/SaveUpdateTransportFeeSelection", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", res.data.snackbar);
            this.learner_transport_fees_installment_details = res.data.learner_transport_fees_installments;
            this.show_apply_transport_card = false;
            this.selected_route="",this.route_stop="",this.route_details_list=[]
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.apply_new_transport_card = false;
        });
    },
    applyTransport(feesinstallmant_id) {
      // alert("feesinstallmant_id"+feesinstallmant_id)
      this.show_apply_transport_card = true;
      this.learnertransportfeesinstallment_id=feesinstallmant_id
      this.selected_route="",this.route_stop="",this.route_details_list=[]
    },
     getInstallmentData(){
      this.transport_installment_list=[],
      this.all_learner_list=[],
       this.learner_transport_fees_installment_details =[]
       const data = {
        academicYear: this.ay_change,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getInstallmentDataByAyWithoutAll", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.all_learner_list = res.data.all_learner_list;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getRoutes() {
      this.route_details_list=[]
      const data = {
        ay:this.ay_change,
        route_stop: this.route_stop,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getRoutes", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.route_details_list = res.data.route_details_list;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
     setName(installment_name) {
      const data = {
        installment:installment_name,
        learner_transport_fees_amount_id:this.learner_transport_fees_amount_id
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getInstallmentAmount", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.fees_applicable=res.data.final_amount
            this.show_fees = true
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
     applyTransportInstallment(item){
      this.learner_transport_fees_amount_id=item.id
      this.apply_payment_card=true
    },
    //  applyTransport() {
    //   this.show_apply_transport_card = true;
    //   this.selected_route="",this.route_stop="",this.route_details_list=[]
    // },
    async fetchTransportApplications() {
        try {
            const data = {
              ay:this.ay_change,
               learner:this.learner
        };
          this.overlay = true;
          const res = await axios.post("/ParentTransport/fetchTransportApplicationsToChangeRoute", data)
          if (res.data.flag == "YES") {
                this.learner_transport_fees_installment_details = res.data.learner_transport_fees_installments;
                this.route_stops = res.data.route_stops;
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
          this.overlay = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
     getTransportDetails(){
      this.show_apply_transport_card = false;
      this.selected_route="",this.route_stop="",this.route_details_list=[]
      const data = {
        ay: this.ay_change,
        learner: this.learner,
      };
      axios
        .post("ParentTransport/getLearnerTransportDetails",data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.learner_transport_fees_list =res.data.learner_transport_fees_list;
            this.route_stops = res.data.route_stops;
            this.all_transport_installments = res.data.transport_installments;
            this.overlay = false;
          } else if(res.data.flag == "No") {
            this.learner_transport_fees_list =[];
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.route_stops = res.data.route_stops;
            if(res.data.is_blocked_for_transport == true){
              this.apply_new_transport_card = false; 
            }else{
            this.apply_new_transport_card = true; 
            }
            this.overlay = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.learner_transport_fees_amount_id=""
          this.apply_payment_card=false
        });  
    },
     onLoad() {
      axios
        .post("ParentTransport/changeLearnerTransportRoute")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay_change = res.data.curreny_ay);
            // this.learner_list = res.data.learner_list;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
.radiospace {
  margin: 1rem !important;
  padding: 0%;
}
sub-row {
  border: 2px solid #424093;
  margin: 1rem;
  border-radius: 5px;
}

i {
  font-size: 20px !important;
}

.v-card__title {
  border: 1px solid #80808040;
  font-weight: bold;
  background-color: #424093;
  color: white;
  text-align: center;
  /* margin-top: 1.5rem; */
}
.card-border {
  border: 2px solid darkblue;
  border-radius: 10px;
  /* padding: 5px; */
  /* margin: 1rem !important; */
  width: auto;
}

.tx-bold {
  font-weight: bold;
  font-size: 14px;
  color: black;
}

i {
  font-size: 26px;
  cursor: pointer;
}

theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #424093 !important;
  color: white !important;
  margin-top: 2.35rem;
  border-radius: 20px;
}

/*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

@media only screen and (max-width: 600px) {
}

.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 150px;
  cursor: zoom-in;
}

.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: auto;
}

v-simple-table {
  border-collapse: collapse;
  border-spacing: 0;
  width: auto;
  border: 1px solid #ddd;
}

th {
  color: white;
  font-weight: bold;
  text-align: center !important;
}

td,
th {
  padding: 6px;
  border: 1px solid #ccc;
  text-align: center;
}
@media all and (max-width: 900px) {
  .padding-bot {
    padding: 8px;
  }
}

@media all and (min-width: 1000px) {
  .padding-metting {
    padding-right: 22px;
  }
}
@media (min-width: 320px) and (max-width: 350px) {
  .padding-bot {
    font-size: 11.6px;
  }
}
@media (min-width: 1000px) and (max-width: 1050px) {
  .padding-bot {
    font-size: 9.6px;
  }
}
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}
 .card-container {
        overflow-x: hidden;
        overflow: hidden;
    }
</style>